/* projects/shared/src/lib/components/filter-field/filter-field.component.scss */
mat-form-field {
  width: 100%;
}
.filter-field {
  align-items: center;
  display: flex;
  gap: 15px;
  width: 100%;
}
mat-slide-toggle {
  flex: 0 0 auto;
  margin-bottom: 22px;
}
/*# sourceMappingURL=filter-field.component.css.map */
